/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
    this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector("ajax-cart");

    this.qtyBtns = this.querySelectorAll("[data-qty-btn]");
    this.qtyBtns.forEach((qtyBtn) =>
      qtyBtn.addEventListener("click", this.manageQtyBtn.bind(this))
    );
  }

  // function which return the rendom number
  makeid(length) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const submitter = evt.submitter;
    if (submitter?.hasAttribute('data-quotify') || submitter?.closest('[data-quotify]')) {
      return;
    }
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector("[data-qty-input]");
    const pdpContainer = this.closest(".product-details-wrapper");

    submitButton.setAttribute("disabled", true);
    submitButton.classList.add("loading");

    let formData = JSON.parse(serializeForm(this.form));

    gtag("event", "add_to_cart", {
      currency: "USD",
      value: formData.product_price,
      items: [
        {
          item_id: `"${formData.id}"`,
          item_name: `"${formData.product_title}"`,
        },
      ],
    });

    // if user is adding wwarranty product on product page
    var isWarrantyProduct = this.form.querySelector(
      "[data-warranty-productcard]"
    );
    if (isWarrantyProduct != null) {
      var warrantyLine = 1;
      var warrantyVariant = this.form.querySelector('[name="id"]').value;
      var randomNumber = this.makeid(10);

      const body = JSON.stringify({
        line: warrantyLine,
        quantity: window.globalVariables.cart.items[0].quantity,
        properties: { "Warranty Added": true, "_Warranty Token": randomNumber },
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          const bodySecond = JSON.stringify({
            id: warrantyVariant,
            quantity: window.globalVariables.cart.items[0].quantity,
            properties: {
              "_Warranty Ref": true,
              "_Warranty Token": randomNumber,
            },
          });

          fetch(`${routes.cart_add_url}`, {
            ...fetchConfig(),
            ...{ body: bodySecond },
          })
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this._updateMinicart();
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              submitButton.classList.remove("loading");
              submitButton.removeAttribute("disabled");
              document
                .querySelector("#PopupModal-warranty-modal .modal")
                ?.classList.remove("open");
              siteOverlay.prototype.hideOverlay();
            });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      addItems.push(JSON.parse(serializeForm(this.form)));
      if (pdpContainer) {
        let addOnItemsEle = pdpContainer.querySelectorAll(
          "[data-addon-selection]:checked"
        );
        addOnItemsEle.forEach((addOn) => {
          if (!addOn.disabled) {
            let addOnParent = addOn.closest("addons-form");
            let addOnJSON = {
              id: addOnParent.querySelector(".variant--id").value,
              quantity: addOnParent.querySelector(".product-quantity").value,
            };
            addItems.push(addOnJSON);
          }
        });
      }

      const body = JSON.stringify({
        items: addItems,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
        .then((response) => response.json())
        .then(async (data) => {
          if (document.querySelector("#PopupModal-quickshop")) {
            document
              .querySelector("#PopupModal-quickshop .close-quickshop")
              .dispatchEvent(new Event("click"));
          }

          if (qtyInput) {
            qtyInput.value = 1;
            qtyInput
              .closest("[data-qty-container]")
              ?.querySelector('[data-for="decrease"]')
              ?.classList.add("disabled");
          }
          var hasWarranty = this.form.querySelector("[data-add-warranty]");

          if (data.errors != null) {
            notificationEle.updateNotification(
              "Cart Error",
              "There are no more quantity available.",
              {
                type: "warning",
                timeout: 5000,
              }
            );
            return;
          }
          if (hasWarranty != null) {
            var zipCodes = window.globalVariables.zipcodes;
            var existingZipCode = Utility.getCookie("zipcode");
            if (zipCodes != "" && zipCodes != null) {
              if (
                existingZipCode != null &&
                existingZipCode != undefined &&
                existingZipCode != ""
              ) {
                zipCodes = zipCodes.split(",");
                if (zipCodes.includes(existingZipCode)) {
                  notificationEle.updateNotification(
                    "Eligible for warranty",
                    "You can claim the warranty from the local store, Visit the store to claim the warranty.",
                    {
                      type: "success",
                      timeout: 5000,
                    }
                  );
                } else {
                  document.querySelector("#PopupModal-warranty-modal .modal") !=
                  null
                    ? (document
                        .querySelector("#PopupModal-warranty-modal .modal")
                        .classList.add("open"),
                      siteOverlay.prototype.showOverlay())
                    : false;
                }
              } else {
                // show popup for verifying the zipcode
                document
                  .querySelector("#PopupModal-check-availability .modal")
                  ?.classList.add("open");
                document.body.classList.add(
                  "verifying-user-zipcode-on-warranty-step"
                );
                siteOverlay.prototype.showOverlay();
              }
            }
          }
          await this._updateMinicart();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove("loading");
          submitButton.removeAttribute("disabled");
        });
    }
  }

  _updateMinicart() {
    if (document.body.classList.contains("template-cart")) {
      this.cartElement.getCartData();
      return false;
    }
    let cartRoute = `${routes.cart_fetch_url}?sections=template-cart-drawer`;

    fetch(cartRoute)
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        let cartHTML = response["template-cart-drawer"];

        if (cartHTML == null) return;
        let parser = new DOMParser();
        cartHTML = parser.parseFromString(cartHTML, "text/html");

        let ajaxCartMini = cartHTML.querySelector("ajax-cart-mini");
        let cartJSONEle = cartHTML.querySelector("[data-cartScriptJSON]");
        document.querySelector("ajax-cart-mini").innerHTML =
          ajaxCartMini.innerHTML;
        document.querySelector("ajax-cart-mini").classList.add("cart-show");
        siteOverlay.prototype.showOverlay();
        if (cartJSONEle != undefined && cartJSONEle != null) {
          window.globalVariables.cart = JSON.parse(cartJSONEle.textContent);
          if (document.querySelectorAll(".cart-count").length > 0) {
            document.querySelectorAll(".cart-count").forEach((item) => {
              item.innerText = window.globalVariables.cart.item_count;
              item.setAttribute(
                "data-cart-count",
                window.globalVariables.cart.item_count
              );
            });
          }
        }

        this._setMaxQty();
        // setTimeout(() => {
        //   document
        //     .querySelector("ajax-cart-mini")
        //     .classList.remove("cart-show");
        // }, 3000);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // Cart HTML fetch done
      });
  }

  /**
   * Set Max Attribute based on current cart quantity
   */
  _setMaxQty = () => {
    try {
      var cartItems = window.globalVariables.cart.items;
      if (cartItems.length) {
        let currentVariantMax = this.form
          .querySelector("[data-qty-input]")
          ?.getAttribute("data-original_max");
        console.log(currentVariantMax, "currentVariantMax");
        if (currentVariantMax) {
          let variantId = this.form.querySelector('[name="id"]')?.value;
          let currentCartVariant = cartItems.find((item) => {
            return item.id == variantId;
          });
          if (currentCartVariant) {
            currentVariantMax -= currentCartVariant.quantity;
            this.form
              .querySelector("[data-qty-input]")
              ?.setAttribute("max", currentVariantMax);
          }
        }
      }
    } catch (err) {
      console.error("error==>", err);
    }
  };

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || "increase";
    let $qtyInput = currentTarget
      .closest("[data-qty-container]")
      .querySelector("[data-qty-input]");
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget
      .closest("[data-qty-container]")
      .querySelector('[data-for="decrease"]');

    if (action == "decrease" && currentQty <= 1) {
      if (decreaseQtyBtn) decreaseQtyBtn.classList.add("disabled");
      return false;
    } else if (action == "decrease") {
      finalQty = currentQty - 1;
      finalQty == 1
        ? decreaseQtyBtn.classList.add("disabled")
        : decreaseQtyBtn.classList.remove("disabled");
    } else {
      if (decreaseQtyBtn) decreaseQtyBtn.classList.remove("disabled");
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
    // this._checkQtyValidation($qtyInput,finalQty)
  }

  _checkQtyValidation = (qtyInput, finalQty) => {
    var maxQty = parseInt(qtyInput?.getAttribute("max") || 0);
    var qtyContainer = qtyInput?.closest("[data-qty-container]");
    if (finalQty < maxQty) {
      qtyContainer
        ?.querySelector('[data-for="increase"]')
        ?.classList.remove("disabled");
    } else {
      qtyContainer
        ?.querySelector('[data-for="increase"]')
        ?.classList.add("disabled");
    }
  };
}
customElements.define("product-form", ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest("form") || this.closest(".form-element");
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json =
      this.form.querySelector("[data-variantJSON]") ||
      this.form
        .closest("[data-product-container]")
        ?.querySelector("[data-variantJSON]");
    let variant_qty_json_ele =
      this.form.querySelectorAll("[data-variantQtyJSON]") ||
      this.form
        .closest("[data-product-container]")
        ?.querySelectorAll("[data-variantQtyJSON]");
    this.variant_qty_json = [];
    variant_qty_json_ele.forEach((ele) => {
      this.variant_qty_json.push(JSON.parse(ele.innerText));
    });
    this.variantPicker = this.dataset.type;

    if (this.formType == "product-page") this.onVariantChange("load");
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event
   */
  onVariantChange(_event) {
    this.setCurrentVariant();
    if (this.formType == "product-page")
      window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton("disable");
      // Variant name update
      let options = this.form.querySelectorAll("[data-optionindex]");
      options.forEach((option) => {
        let labelID = "option" + option.dataset.optionindex;
        const selectedValue = option.querySelector(
          'input[type="radio"]:checked'
        );
        const label = option.querySelector(".selected-option");
        if (!label || !labelID || !selectedValue) return;
        label.innerHTML = selectedValue.value;
      });
    } else {
      if (this.formType == "grid") {
        const productGrid = this.closest("[data-product-grid]");
        this.renderProductInfo(this.currentVariant, productGrid);
        this._updateLinks(productGrid);
      } else {
        const productPage = this.closest("[data-product-container]");
        this.renderProductInfo(this.currentVariant, productPage);
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton("enable");
    }

    this._manageQtyInputValidation();
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid
   */
  _updateLinks(productGrid) {
    if (!this.currentVariant || !productGrid) return;
    const variantURL = "?variant=" + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll(".product-link");
    formLinks.forEach((link) => {
      let href = link.href.split("?")[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll(".variant_selector").forEach((selector) => {
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(
      this.querySelectorAll("fieldset:not(.addon-fieldset)")
    );
    return fieldsets.map((fieldset) => {
      return Array.from(
        fieldset.querySelectorAll("input:not(.addon-swatch)")
      ).find((radio) => radio.checked).value;
    });
  }

  /**
   * change value of currentVariant when variant being changed
   */
  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options =
      this.variantPicker == "variant-select"
        ? this._getOptionsFromSelect()
        : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/false,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if (!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if (this.formType == "product-page")
      window.history.replaceState(
        {},
        "",
        `${this.dataset.url}?variant=${currentVariant.id}`
      );

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Render Product data based on current variant
   * @param {event} currentVariant
   * @param {element} container
   */
  renderProductInfo(currentVariant, container) {
    if (!currentVariant || !container) return;

    // Price Update
    let price = Shopify.formatMoney(
      currentVariant.price,
      window.globalVariables.money_format
    );
    let compare_price = Shopify.formatMoney(
      currentVariant.compare_at_price,
      window.globalVariables.money_format
    );
    let priceElement = container.querySelector("[data-currentPrice]");
    let comparePriceElement = container.querySelector("[data-comparePrice]");

    if (priceElement) priceElement.innerHTML = price;
    if (comparePriceElement) {
      comparePriceElement.innerHTML = compare_price;
      if (currentVariant.compare_at_price <= 0) {
        comparePriceElement.style.display = "none";
      } else {
        comparePriceElement.style.display = "block";
      }
    }

    // Grid Image Update on variant selection
    if (this.formType == "grid") {
      if (!currentVariant.featured_image) return;
      const featuredImage = container.querySelector("[data-feauredImage]");
      let updatedSrc = currentVariant.featured_image.src;
      if (updatedSrc) {
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    } else {
      if (!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(
        `.product--media[data-mediaID="${imageID}"]`
      );
      if (this.formType == "quickshop") {
        imageSlide = document.querySelector(
          `.quickshop-slider .product--media[data-mediaID="${imageID}"]`
        );
      }
      if (!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(
        imageSlide
      );
      if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if (productSlider) productSlider.slideTo(slideIndex, 2000, true);
    }

    // Variant name update
    let options = this.form.querySelectorAll("[data-optionindex]");
    options.forEach((option) => {
      let labelID = "option" + option.dataset.optionindex;
      const label = option.querySelector(".selected-option");
      if (!label || !labelID) return;
      label.innerHTML = currentVariant[labelID];
    });
  }

  /**
   * Enable/Disable add to cart button and qty button based on max attribute
   */
  _manageQtyInputValidation = () => {
    try {
      let variantObj = this.variant_qty_json.find((variant) => {
        return variant.id == this.currentVariant.id;
      });
      if (this.form.querySelector("[data-original_max]")) {
        let qtyInput = this.form.querySelector("[data-qty-input]");
        let increaseBtn = this.form?.querySelector('[data-for="increase"]');
        let decreaseBtn = this.form?.querySelector('[data-for="decrease"]');

        increaseBtn?.classList.remove("disabled");
        decreaseBtn?.classList.remove("disabled");
        qtyInput.setAttribute("data-original_max", variantObj.quantity);
        qtyInput.setAttribute("max", variantObj.quantity);
        let currentQty = parseInt(qtyInput.value);
        this._setMaxQty();
        let maxQty = parseInt(qtyInput.getAttribute("max"));
        let original_max = parseInt(qtyInput.getAttribute("data-original_max"));
        if (maxQty <= 1) {
          increaseBtn?.classList.add("disabled");
          decreaseBtn?.classList.add("disabled");
        }
        if (maxQty <= 0 && original_max > 0) {
          this.form.querySelector('[name="add"]').classList.add("disabled");
          this.form.querySelector('[name="add"] .add-text').innerHTML =
            window.variantStrings.already_in_cart;
        } else {
          this.form.querySelector('[name="add"]').classList.remove("disabled");
          this.form.querySelector('[name="add"] .add-text').innerHTML =
            window.variantStrings.addToCart;
        }
        if (maxQty > 0 && maxQty < currentQty) {
          qtyInput.value = qtyInput.getAttribute("max");
          if (qtyInput == 1) {
            decreaseBtn?.classList.add("disabled");
          }
          if (parseInt(qtyInput.value) >= maxQty) {
            increaseBtn?.classList.add("disabled");
          }
        }
      }
    } catch (err) {
      console.error("error==>", err);
    }
  };

  /**
   * Set Max Attribute based on current cart quantity
   */

  _setMaxQty = () => {
    try {
      var cartItems = window.globalVariables.cart.items;
      if (cartItems.length) {
        let currentVariantMax = this.form
          .querySelector("[data-qty-input]")
          ?.getAttribute("data-original_max");

        if (currentVariantMax) {
          let variantId = this.form.querySelector('[name="id"]')?.value;
          let currentCartVariant = cartItems.find((item) => {
            return item.id == variantId;
          });
          if (currentCartVariant) {
            currentVariantMax -= currentCartVariant.quantity;
            this.form
              .querySelector("[data-qty-input]")
              ?.setAttribute("max", currentVariantMax);
          }
        }
      }
    } catch (err) {
      console.error("error==>", err);
    }
  };
  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == "disable") {
      this.addBtn.setAttribute("disabled", true);
      this.addBtn.classList.add("disabled-btn");
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.unavailable;
      if (this.form.querySelector(".data-product-form-qty-wrapper"))
        this.form
          .querySelector(".data-product-form-qty-wrapper")
          ?.classList.add("d-none");
    } else if (this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute("disabled", true);
      this.addBtn.classList.add("disabled-btn");
      if (this.addBtn.querySelector(".add-text"))
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.soldOut;
      if (this.form.querySelector(".data-product-form-qty-wrapper"))
        this.form
          .querySelector(".data-product-form-qty-wrapper")
          ?.classList.add("d-none");
    } else {
      this.addBtn.removeAttribute("disabled");
      this.addBtn.classList.remove("disabled-btn");
      if (this.form.classList.contains("cart-upsell-form")) {
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.upsellAddText;
      } else {
        this.addBtn.querySelector(".add-text").textContent =
          window.variantStrings.addToCart;
      }
      if (this.form.querySelector(".data-product-form-qty-wrapper"))
        this.form
          .querySelector(".data-product-form-qty-wrapper")
          ?.classList.remove("d-none");
    }
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    console.log(this.variant_json, "this.variant_json");
    this.variantData =
      this.variantData || this.variant_json
        ? JSON.parse(this.variant_json.textContent)
        : false;
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    if (window.globalVariables.template != "collection") {
      this.form = this.closest("form") || this.querySelector(".form-element");
      this.formType = this.form.dataset.format;

      const colorSwatchContainer = this.querySelector(".color-swatch");
      if (colorSwatchContainer) {
        const colorSwatches = colorSwatchContainer.querySelectorAll(".swatch");
        colorSwatches.forEach((swatch) => {
          let colorHandle = swatch.querySelector('input[type="radio"]').dataset
            .handle;
          let swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch
            .querySelector(".swatch-label")
            .setAttribute("style", swatchStyle);
        });
      }
    }
  }
}
customElements.define("variant-radios", VariantRadios);
